export default __webpack_public_path__ + "static/style4.2_Elena-01de09db6dd2e044fd810d8022cecd49.wav";